module.exports = __webpack_public_path__ + "img/hospitium-10.45674262.jpg";